import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';

export const SpinOptions = {
    suffix: i18n.t('厘米'),
    step: 0.1,
    allowDecimal: true,
    toFixed: 2,
    max: 50,
    min: 0,
};

export const ScaleSpinOptions = {
    suffix: i18n.t('%'),
    step: 1,
    min: 1,
    max: 100,
};
export const DEFAULT_SCALE = 100; // 默认缩放比例100%
export const DEFAULT_SCALE_STEP = 0.01; // 默认step

const SpinStyle = {
    fontSize: '12px',
};

export const RESOLUTION_SIZE = {
    RESOLUTION_640_480: '640*480',
    RESOLUTION_720_512: '720*512',
    RESOLUTION_800_600: '800*600',
    RESOLUTION_1024_768: '1024*768',
    RESOLUTION_1280_1024: '1280*1024',
};

// 填充方式
const RESOLUTION_SELECTIONS = Object.keys(RESOLUTION_SIZE).map(key => ({
    key: RESOLUTION_SIZE[key],
    content: RESOLUTION_SIZE[key],
}));

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.SPIN,
        name: FormItemName.HEIGHT,
        label: FormItemLabelName.HEIGHT,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.WIDTH,
        label: FormItemLabelName.WIDTH,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.SCALE_HEIGHT,
        label: FormItemLabelName.SCALE_HEIGHT,
        options: ScaleSpinOptions,
        style: SpinStyle,
        defaultValue: 1,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.SCALE_WIDTH,
        label: FormItemLabelName.SCALE_WIDTH,
        options: ScaleSpinOptions,
        style: SpinStyle,
        defaultValue: 1,
    },
    {
        name: FormItemName.SIZE_ADJUST,
        type: FormItemType.CHECKBOX,
        label: FormItemLabelName.SIZE_ADJUST,
        defaultValue: false,
    },
    {
        name: FormItemName.RELATIVE_IMAGE_ORIGINAL_SIZE,
        type: FormItemType.CHECKBOX,
        label: FormItemLabelName.RELATIVE_IMAGE_ORIGINAL_SIZE,
        defaultValue: true,
        style: { marginBottom: -4, marginTop: -4 },
    },
    {
        name: FormItemName.BEST_PLAY_SCALE,
        type: FormItemType.CHECKBOX,
        label: FormItemLabelName.BEST_PLAY_SCALE,
        defaultValue: false,
        style: { marginBottom: 0 },
    },
    {
        name: FormItemName.ORIGINAL_SIZE,
        type: FormItemType.TEXT,
        value: FormItemLabelName.ORIGINAL_SIZE,
        style: { color: 'rgba(0, 0, 0, 0.88)', fontWeight: 500, marginBottom: -8 },
    },
    {
        name: FormItemName.RESOLUTION_TEXT,
        type: FormItemType.TEXT,
        value: FormItemLabelName.RESOLUTION,
        style: { marginBottom: -4 },
    },
    {
        name: FormItemName.RESOLUTION,
        type: FormItemType.SELECT,
        options: {
            selectOptions: RESOLUTION_SELECTIONS,
        },
        value: RESOLUTION_SIZE.RESOLUTION_640_480,
        style: { marginBottom: -4 },
    },
    {
        name: FormItemName.ORIGINAL_SIZE_CONTENT,
        type: FormItemType.TEXT,
    },
    {
        name: FormItemName.RESET_ORIGINAL_SIZE,
        type: FormItemType.BUTTON,
        options: {
            text: FormItemLabelName.RESET_ORIGINAL_SIZE,
        },
        style: { maxWidth: 72, marginTop: 0 },
    },
];
